import React, { VoidFunctionComponent, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemToSynchronizeInfo } from '../../context/SynchronizationStatusContext';
import { Icon, IconType } from '../../misc/Icon/Icon';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ItemsToSynchronizeListItem.module.css';

export type ItemsToSynchronizeListItemProps = ComponentProps<'div'> & {
  itemToSynchronizeInfo: ItemToSynchronizeInfo;
};

export const ItemsToSynchronizeListItem: VoidFunctionComponent<ItemsToSynchronizeListItemProps> =
  React.memo((props) => {
    const { itemToSynchronizeInfo, className, ...remainingProps } =
      prepareProps({ props, ignoreChildren: true });
    const { t } = useTranslation('record-it-components');

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.listItem)}
      >
        <div className={styles.header}>
          {!itemToSynchronizeInfo.failed ? undefined : (
            <Icon
              name="times"
              type={IconType.Light}
              className={styles.failedIcon}
              data-testid="ItemsToSynchronizeListItem.failedIcon"
            ></Icon>
          )}
          <span className={styles.entityName}>
            {itemToSynchronizeInfo.entityName}
          </span>
        </div>
        <div>
          <span>{t('synchronization.ItemsToSynchronizeListItem.idLabel')}</span>
          <span className={styles.id}>{itemToSynchronizeInfo.id}</span>
        </div>
      </div>
    );
  });
